/**
 * Column ids ON by default in the card layouts (opt-out via Column Settings,
 * unlike the always-on cardFixedColumnIdsFor set). Cards start with only
 * these + the fixed header; everything else is opt-in.
 *
 * Kept in its own module, apart from searchInspectorRegistry, because the saved
 * view definition needs it too. The registry imports the inspector components,
 * and the definition code must stay a plain function module.
 */
export function cardDefaultColumnIdsFor(entityId: string): string[] {
    if (entityId === 'LocationZonePlayer') {
        return ['currently_playing'];
    }
    return [];
}
